import React, { useState, useEffect, Fragment, useRef } from 'react'
import '../../../../assets/css/pantalla1.css'
import '../../../../assets/css/cartaConsentimiento.css'
import { Container, Row, Col, Label } from 'reactstrap';
import { useEncuestaCliente } from '../../../../hooks/tomaMuestra/useEncuestaCliente';
import { ModalEnd } from '../ModalEnd';
import 'animate.css';
import { useLogin } from '../../../../hooks/tomaMuestra/useLogin';
import { ModalEndCancell } from '../ModalEndCancell';
import { ComponentQuestin } from './ComponentQuestin';
import { useHistory, useParams } from "react-router-dom";
import { sendRequest } from "../../../../hooks/requests/useRequest";
import { Card } from 'primereact/card';
import { useSweetAlert } from "../../../../hooks/sweetAlerts/useSweetAlert";







export const IndexEncuestaClient = () => {

    const {

        handleEnd, method, modalTitle, toggle, modal, loading,
        navigateInicio, nameModal, getEncuesta, hour, minute, second, surnames,
        handleEndCancell, method2, toggle2, modal2, getEncuestaCancell, loading2, dinamica, navigateNext, navigatePrev, saveQuestion, questionOpen, showAlternativeQ

    } = useEncuestaCliente();


    const { time, reload } = useLogin();

    let name = localStorage.getItem('nameUser');
    let name2 = localStorage.getItem('flebotomisaNombre');
    let name5 = localStorage.getItem('willson');


    const [show, setShow] = useState(true);
    const [show1, setShow1] = useState(true);
    const [modalPrueba, setModalPrueba] = useState("");
    const [modalPrueba2, setModalPrueba2] = useState("");

    const [loadingPatient, setLoadingPatient] = useState(false);
    const [createSweet, sweetConfirmation, sweetDelete, sweetError, createSweett, sweetConfirmationUpdate, sweetConfirmRepeatExam, sweetConfirmationChangeClient, sweetConfirmationCancel, sweetValidDate, sweetDeleteBacterium1, sweetDoctorDelete, sweetAgreements, sweetAgreementMode, sweetConfirmationCsv, sweetDeleteGlobal, sweetAcceptGlobal] = useSweetAlert()



    const history = useHistory();

    const { nimm } = useParams();

    useEffect(() => {
        if (nimm !== undefined) {
            getDataFromNimPost(nimm)
        }
    }, [nimm]);


    // ==========================================
    // INICIO DE NUEVO CÓDIGO: BLOQUEO DE GESTO "ATRÁS"
    // ==========================================
    useEffect(() => {
        // 1. Forzamos una entrada nueva en el historial al montar el componente
        window.history.pushState(null, null, window.location.href);

        const handlePopState = (event) => {
            // 2. El usuario hizo el gesto de regresar (swipe o botón atrás) en la tablet
            // Volvemos a empujar el estado para mantenerlo "atrapado" en esta vista
            window.history.pushState(null, null, window.location.href);

            // 3. Mostramos la alerta de SweetAlert para explicarle por qué no pasó nada
            createSweet(
                "warning",
                "Acción no permitida",
                "Navegación bloqueada",
                "Para evitar perder la información de la toma de muestra, por favor utiliza los botones de la pantalla."
            );
        };

        // Escuchamos el evento de navegación del historial
        window.addEventListener('popstate', handlePopState);

        // Evitar que el usuario recargue la página por accidente (F5 o swipe hacia abajo)
        const handleBeforeUnload = (e) => {
            e.preventDefault();
            e.returnValue = ''; // Necesario para la mayoría de navegadores modernos
        };
        window.addEventListener('beforeunload', handleBeforeUnload);

        // 4. Limpieza: Se ejecuta cuando el componente muere (para no afectar otras pantallas)
        return () => {
            window.removeEventListener('popstate', handlePopState);
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []); // El array vacío equivale a ponerlo en el constructor o Page_Load de C#
    // ==========================================
    // FIN DE NUEVO CÓDIGO
    // ==========================================



    const getDataFromNimPost = async (nimm) => {

        setLoadingPatient(false);

        let body = {
            nim: nimm.substring(0, 14),
            id_departament: localStorage.getItem('prueba')

        }

        let requestOptions = {
            method: 'POST',
            body: JSON.stringify(body)
        };

        const respuesta = await sendRequest(requestOptions, "Sass/GetDataNim");
        setLoadingPatient(true);

        if (respuesta.code === 200) {
            let name = respuesta.data.paciente.name
            let surname = respuesta.data.paciente.surnames
            ////console.log(surname);

            setModalPrueba(name)
            setModalPrueba2(surname);

        }
    }










    return (
        <Fragment>
            <Container fluid={true} className='bg-barra1 '>
                <Col xs="12" sm="12" md="12" lg="12" xl="12" className='p-l-0 p-r-0'>
                    <Row>
                        <Col xs="12" sm="12" md="12" lg="12" xl="12" className="p-l-0"> <br />
                            <div className='box-departamento'>
                                <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ textAlign: "-webkit-center" }}>
                                    <Row>
                                        <Col xs="2" sm="2" md="2" lg="2" xl="2" className='p-l-0'>
                                            <Label className='r'>{time}</Label>
                                        </Col>
                                        <Col xs="1" sm="1" md="1" lg="1" xl="1">
                                        </Col>
                                        <Col xs="6" sm="6" md="6" lg="6" xl="6" >
                                            <label className='r'>Toma de Muestra</label>
                                        </Col>
                                        <Col xs="1" sm="1" md="1" lg="1" xl="1">
                                        </Col>
                                        <Col xs="2" sm="2" md="2" lg="2" xl="2" className='p-1' style={{ textAlign: "-webkit-right" }}>
                                            {
                                                show1 ? (<label className='rc'>{hour}:{minute}:{second}</label>) : ""
                                            }
                                        </Col>
                                        <Col sm="1" className='p-2' >
                                            {/* {
                                                show1 ? (<img className=" " src={require("../../../../assetsToma/imagenes/Cronometro.png")} style={{ width: "57%" }} alt="" />
                                                ) : ""
                                            } */}
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                        </Col>

                        <Col xs="12" sm="12" md="12" lg="12" xl="12">
                            <Row>
                                <Col xs="12" sm="12" md="12" lg="12" xl="12" className='p-l-0 p-r-0' >
                                    <Card className='shadow-sm' >
                                        <ComponentQuestin
                                            items={dinamica}
                                            {
                                            ...{ navigateNext, navigatePrev, saveQuestion, questionOpen, showAlternativeQ, handleEnd }
                                            }
                                        />

                                    </Card>

                                    <div className='tap-top' style={{ display: "block" }} onClick={() => { setShow(!show); }}><i className="icon-angle-double-up f-24"></i>
                                    </div>
                                </Col>

                                <Col
                                    style={{
                                        position: 'fixed',
                                        right: 0,
                                        zIndex: 5,
                                        width: '25%',
                                        maxWidth: '250px',
                                        height: 'auto',
                                        minHeight: '200px',
                                        borderTopLeftRadius: '12px',
                                        top: '48vh',
                                        paddingLeft: 0
                                    }}
                                    className='p-l-0'
                                >

                                    <Col xs="12" sm="12" md="12" lg="12" xl="12"><br /> <br />

                                        {
                                            show ?
                                                (
                                                    <div></div>
                                                )
                                                :
                                                (
                                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">
                                                        <div className='username-Active ' >
                                                            <Col sm="12">
                                                                <Row>
                                                                    <Col sm="3" className='p-l-0 p-r-0 p-0' style={{ textAlign: "-webkit-center" }} > <br />

                                                                        <i className="fa fa-circle icon-active-small"></i>
                                                                    </Col>
                                                                    <Col sm="9" className='p-l-0 p-r-0'> <br />
                                                                        <label className='label-menuToma p-0 ' >{name2}</label>
                                                                    </Col>

                                                                </Row>
                                                            </Col>
                                                        </div> <br />
                                                        {/* onClick={reload} */}
                                                        <div className='username-Active pointer'  >
                                                            <Col sm="12">
                                                                <Row>
                                                                    <Col sm="3" className='p-l-0 p-r-0 p-t-2 ' style={{ textAlign: "-webkit-center" }}> <br />
                                                                        <img className=" " src={require("../../../../assetsToma/imagenes/Recargar.png")} style={{ width: "43%" }} alt="" />
                                                                    </Col>
                                                                    <Col sm="9" className='p-l-0 p-r-0 ' onClick={reload}> <br />
                                                                        <label className='r-label-active p-0 pointer'>{"Recargar"}</label>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </div> <br />
                                                        <div className='username-Active pointer' onClick={() => { setShow1(!show1); }}>
                                                            <Col sm="12">
                                                                <Row>
                                                                    <Col sm="3" className='p-l-0 p-r-0 p-t-2 ' style={{ textAlign: "-webkit-center" }}> <br />
                                                                        <img className=" " src={require("../../../../assetsToma/imagenes/Cronometro.png")} style={{ width: "45%" }} alt="" />
                                                                    </Col>
                                                                    <Col sm="9" className='p-l-0 p-r-0 '> <br />
                                                                        <label className='r-label-active p-0 pointer'>{"Cronómetro"}</label>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </div><br />
                                                        {/* 50% */}
                                                        <div className='username-Active pointer' onClick={handleEndCancell}>
                                                            <Col sm="12">
                                                                <Row>
                                                                    <Col sm="3" className='p-l-0 p-r-0 p-t-2 ' style={{ textAlign: "-webkit-center" }}>  <br />
                                                                        <img className=" " src={require("../../../../assetsToma/imagenes/Omitir.png")} style={{ width: "50%" }} alt="" />
                                                                    </Col>
                                                                    <Col sm="9" className='p-l-0 p-r-0 '> <br />
                                                                        <label className='r-label-active p-0 pointer' >{"Omitir Encuesta"}</label> <br />
                                                                        {/* <label className='cambios'>{hour}</label> */}
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </div>
                                                    </Col>
                                                )
                                        }
                                    </Col>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Container>
            <ModalEnd
                {...{ method, modalTitle, toggle, modal, loading, navigateInicio, nameModal, getEncuesta, surnames, modalPrueba, modalPrueba2, loadingPatient }}

            />
            <ModalEndCancell
                {...{
                    method2, toggle2, modal2, loading2, navigateInicio, getEncuestaCancell, surnames, nameModal, modalPrueba, modalPrueba2, loadingPatient
                }}

            />
        </Fragment>

    )
}


